import type { FC } from "react";
import { useMemo } from "react";

import IntentSignalsEventsTooltipContainer from "app/pages/sales-intelligence/pages/company-analysis/components/signals/SignalEventInfo/IntentSignalEventInfo/IntentSignalsEventsTooltip/IntentSignalsEventsTooltipContainer";
import { getIntentSignalCountries } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/getters/getIntentSignalCountries";
import type { IntentSignalCompanyEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import IntentSignalsEventsTooltipContent from "app/pages/sales-intelligence/pages/company-analysis/components/signals/SignalEventInfo/IntentSignalEventInfo/IntentSignalsEventsTooltip/IntentSignalsEventsTooltipContent";

import IntentSignalEventTopics from "./IntentSignalEventTopics";

type Props = {
    signal: IntentSignalCompanyEventDto;
};

const IntentSignalCompanyEventTopics: FC<Props> = ({ signal }) => {
    const topicItems = useMemo(
        () =>
            signal.events.map(({ topic, countriesScopes }) => ({
                topic,
                tooltipContent: (
                    <IntentSignalsEventsTooltipContainer>
                        <IntentSignalsEventsTooltipContent countries={getIntentSignalCountries(countriesScopes)} />
                    </IntentSignalsEventsTooltipContainer>
                ),
            })),
        [signal],
    );

    return <IntentSignalEventTopics topics={topicItems} />;
};

export default IntentSignalCompanyEventTopics;
